import { render, staticRenderFns } from "./ReadonlyField.vue?vue&type=template&id=69356b0c&"
import script from "./ReadonlyField.vue?vue&type=script&lang=js&"
export * from "./ReadonlyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports